
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/privacy-policy",
      function () {
        return require("private-next-pages/policy/privacy-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/privacy-policy"])
      });
    }
  